import { WebRTCPlayer } from "./WebRTCPlayer";

interface Props {
  streamName: string | null;
  label?: string;
  onDecodeError?: () => void;
  onTranscodeFailed?: () => void;
  // Error del player NO manejado por los fallbacks de codec (ver WebRTCPlayer.onError).
  // Playback lo usa para volver a 1x cuando fallo un stream de reproduccion rapida.
  onError?: (message: string) => void;
  paused?: boolean;
  playbackRate?: number;
  onTimeUpdate?: (elapsedSeconds: number) => void;
  onStreamEnded?: () => void;
}

export function PlaybackPlayer({
  streamName, label, onDecodeError, onTranscodeFailed, onError,
  paused, playbackRate, onTimeUpdate, onStreamEnded,
}: Props) {
  return (
    <WebRTCPlayer
      streamName={streamName}
      label={label}
      showAudioToggle={true}
      onDecodeError={onDecodeError}
      onTranscodeFailed={onTranscodeFailed}
      onError={onError}
      connectingHint="Cargando grabacion..."
      paused={paused}
      playbackRate={playbackRate}
      onTimeUpdate={onTimeUpdate}
      onStreamEnded={onStreamEnded}
    />
  );
}
